import { formTypes } from "../constants/websiteCheck";

export const getCategoryFromDocumentType = (documentType: string) => {
  // if(formTypes.find(f => f.value)){
  //   return "forms"
  // }
  switch (documentType) {
    case "dat":
    case "dat_ch":
      return "datenschutzerklaerung";
    case "imp":
      return "impressum";
    case "cok":
      return "cookie_bestimmungen";
    case "img":
      return "forms";
    default:
      return documentType;
  }
};
